import { getPortCallTypeRefsRequest } from '@gat-ship/ref-data'
import type { PortCallTypeRef } from '@gat-ship/types'

/**
 * Fetch the tenant's port call types from the shared ref-data lookup
 * (`GET /ref-data/port-calls/types`) — the same source the create-portcall
 * picker reads.
 *
 * There are no write endpoints yet: add/edit/remove are local-state only
 * (see `usePortCallTypesDataSource`). When the management endpoints land,
 * add the POST/PUT/DELETE wrappers here and call them from the datasource.
 */
export async function getPortCallTypesRequest(): Promise<PortCallTypeRef[]> {
  return getPortCallTypeRefsRequest()
}
